<template>
  <div>
    <common-dialog ref="dialog" width="800px" unit="激活名额" edit-title id-key="PlaceId" :data="data"
      form-label-width="85px" :form-rules="rules" :save-func="isSubmit?api.submit:api.save" :get-data-func="api.info" close-on-saved
      @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed" :before-save="onBeforeSave"
      @details-opened="onDetailsOpened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属机构" prop="DpId">
              <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="data.DpId"
                :clearable="false" :accordion="true" :parentSelect="true" placeholder="请选择"
                @node-select="onTreeSelect($event)" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目" prop="Item">
              <el-select v-model="data.Item" clearable>
                <el-option value="实操" />
                <el-option value="模拟" />
                <el-option value="课堂" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作日期" prop="PlaceDate">
              <el-date-picker v-model.trim="data.PlaceDate" type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作类型" prop="PlaceType">
              <el-select v-model="data.PlaceType">
                <el-option :value="1" label="购买" />
                <el-option :value="2" label="回收" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单价" prop="Price">
              <el-input v-model="data.Price" type="number" @blur="count" placeholder="请填写金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量" prop="Quantity">
              <el-input v-int v-model="data.Quantity" @blur="count" placeholder="请填写数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金额" prop="Amount">
              {{data.Amount}}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24" style="margin-top: -30px;">
            <div style="text-align: right;">
              <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
              <el-button type="success" @click="setPrice" :disabled="PlaceDtsDtos.length==0">获取合作单价填入</el-button>
            </div>
            <el-form-item label="明细信息" prop="PlaceType">
              <el-table ref="place" :data="PlaceDtsDtos" border size="mini" style="margin: 7px 0 0;">
                <el-table-column prop="CarType" label="培训车型" align="center">
                  <template slot-scope="{row}">
                    <el-select v-model="row.CarType" filterable @change="changeNum(row,1)">
                      <el-option v-for="item in carTypeList" :key="item.DataName" :value="item.DataName" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="Price" label="单价" width="110" align="center">
                  <template slot-scope="{row}">
                    <el-input v-model="row.Price" type="number" @blur="changeNum(row)" />
                  </template>
                </el-table-column>
                <el-table-column prop="Quantity" label="数量" width="110" align="center">
                  <template slot-scope="{row}">
                    <el-input v-model="row.Quantity" v-int @blur="changeNum(row)" />
                  </template>
                </el-table-column>
                <el-table-column prop="Amount" label="金额" width="100" align="center" />
                <el-table-column label="操作" width="80" align="center">
                  <template slot-scope="{row,$index}">
                    <el-button @click="deleteItem(row,$index)" type="text">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请填写备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="warning" @click="toSave(0)">保 存</el-button>
        <el-button type="primary" v-if="data.Status==0||data.Status==2" @click="toSave(1)">提 交</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>

<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import api from "@/api/op/activeplace";
  import treeSelect from "@/components/common/treeSelect";
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      treeSelect,
    },
    data() {
      return {
        data: {
          PlaceId: 0,
          PlaceType: 1,
          PlaceDate: this.$commonJs.getToday(),
          Remark: null,
          DpId: null,
          DpName: "",
          Status: 0,
          Item: "",
          Price: null,
          Quantity: null,
          Amount: 0,
          PlaceDtsDtos: []
        },
        api,
        dpApi: require("@/api/basic/dp").default,
        coopApi: require("@/api/op/coop").default,
        basicApi: require("@/api/basic/data").default,
        rules: {
          DpId: [{ required: true, message: "请选择所属组织" }],
          PlaceDate: [{ required: true, message: "请选择操作日期" }],
          PlaceType: [{ required: true, message: "请选择操作类型" }],
          Price: [{ required: true, message: "请填写单价" }],
          Quantity: [{ required: true, message: "请填写数量" }],
          Item: [{ required: true, message: "请选择项目" }],
        },
        FirstId: 0,
        TreeData: [],
        carTypeList: [],
        PlaceDtsDtos: [],
        DeletePlaceDts: [],
        isSubmit: false,
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
      };
    },
    methods: {
      onCreateOpened() {
        this.GetBaseData();
        this.getTreeData();
      },
      onEditOpened(data) {
        this.GetBaseData();
        this.data = data;
        // this.PlaceDtsDtos = data.PlaceDtsDtos;
        // if (this.PlaceDtsDtos.length > 0) {
        //   this.PlaceDtsDtos.forEach((e) => {
        //     e.T = null;
        //   });
        // }
        this.getTreeData();
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      count() {
        if(!(this.data.Price > 0)) this.data.Price = 0;
        if(!(this.data.Quantity > 0)) {
          this.data.Quantity = 1;
          this.$message.error("数量至少为1");
        }
        this.data.Amount = this.data.Price*this.data.Quantity;
      },
      getTreeData() {
        this.dpApi.getAuthList({ DpTypes: [2,3,4], Status: 3, NoReturnParent: true }).then((res) => {
          this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
          if (this.data.DpId) {
            this.$refs.treeSelect.setData(this.data.DpId);
            var obj = res.Data.find(x => {
              return x.DpId==this.data.DpId;
            })
            if(obj) {
              this.FirstId = obj.FirstId;
            }
          }
        });
      },
      GetBaseData() {
        this.basicApi.list({ ClassName: "培训车型", Status: 1 }).then(res => {
          this.carTypeList = res.Data
        });
      },
      toSave(type) {
        this.isSubmit = type==1;
        this.save();
      },
      add() {
        if (!this.data.DpId) {
          this.$message.warning("请选择所属机构,可根据机构和车型获取合作单价");
        } else {
          this.PlaceDtsDtos.push({
            CarType: null,
            Price: 0,
            Quantity: 0,
            Amount: 0,
            T: 0,
            PlaceDtsId: 0,
            PlaceId: this.data.PlaceId
          });
        }
      },
      deleteItem(row, index) {
        if (row.PlaceDtsId > 0) {
          row.T = 2;
          this.DeletePlaceDts.push(row);
        }
        this.PlaceDtsDtos.splice(index, 1)
      },
      onTreeSelect(t) {
        if (!t) {
          this.data.DpId = null;
          this.FirstId = 0;
        } else {
          this.data.DpId = t.DpId;
          this.FirstId = t.FirstId;
        }
      },
      changeNum(row, type) {
        if (!(row.T === 0)) {
          row.T = 1
        }
        // if (type == 1 && row.DpId) {
        //   this.getprice(row);
        // }
        row.Amount = row.Price * row.Quantity;
      },
      // getprice(row) {
      //   this.loading(true);
      //   this.coopApi.getOutPrice({ DpId: this.data.DpId, CarType: row.CarType }).then(res => {
      //     this.loading(false);
      //     if (res.Code == 0 && res.Data != null) {
      //       row.Price = parseFloat(res.Data);
      //       row.Amount = row.Price * row.Quantity;
      //     }
      //   });
      // },
      setPrice() {
        this.PlaceDtsDtos.forEach(e => {
          if(e.CarType) {
            this.coopApi.getOutPrice({ DpId: this.data.DpId, CarType: e.CarType }).then(res => {
              if (res.Code == 0 && res.Data != null) {
                e.Price = parseFloat(res.Data);
                e.Amount = e.Price * e.Quantity;
                if (!(e.T === 0)) {
                  e.T = 1
                }
              }
            });
          }
        })
      },
      onBeforeSave() {
        // if (this.PlaceDtsDtos.length == 0) {
        //   this.$message.error("请添加明细信息");
        //   return false;
        // }
        // var error = "";
        // var cartypes = [];
        // // const r = /^\+?[1-9][0-9]*$/;//正整数
        // this.PlaceDtsDtos.forEach(e => {
        //   if (!error) {
        //     if (e.CarType == null) {
        //       error = "请选择培训车型";
        //     }
        //     if (cartypes.indexOf(e.CarType) > -1) {
        //       error = e.CarType + "已存在相同的车型";
        //     }
        //     if(!(e.Quantity > 0)) {
        //       error = e.CarType + "-数量请填写正整数";
        //     }
        //     if (!(e.Price > 0)) {
        //       e.Price = 0
        //     }
        //     cartypes.push(e.CarType);
        //   }
        // });
        // if (!error.length) {
        //   this.data.PlaceDtsDtos = [];
        //   this.PlaceDtsDtos.forEach(e => {
        //     if (e.T === 0 || e.T === 1) {
        //       this.data.PlaceDtsDtos.push(e);
        //     }
        //   });
        //   this.data.PlaceDtsDtos = this.data.PlaceDtsDtos.concat(this.DeletePlaceDts);
        // } else {
        //   this.$message.error(error);
        //   return false;
        // }
      },
      onClosed() {
        this.FirstId = 0;
        this.isSubmit = false;
        this.TreeData = [];
        this.PlaceDtsDtos = [];
        this.DeletePlaceDts = [];
        this.$refs.treeSelect.clearHandle();
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>